export const sortStrings = (a: string, b: string): number => {
  return a.localeCompare(b, undefined, { caseFirst: 'upper' });
};
